import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './theme/theme';
import CssBaseline from '@mui/material/CssBaseline';
import AppRoutes from './Routes';

// Placeholder components
const ModelViewer = () => <div>Model Viewer Page</div>;
const Project = () => <div>Project Page</div>;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppRoutes /> {/* All routes handled here */}
      </Router>
    </ThemeProvider>
  );
}

export default App;
